import React from 'react';

import logo from './../../src/assets/images/regailator-logo-wordmark.png'

//-----------------------|| LOGO SVG ||-----------------------//

const Logo = ({ height = 68 }) => {
    return (
        <img src={logo} alt="ConformBridge" style={{ height, width: 'auto', display: 'block' }} />
    );
};

export default Logo;
